import React from 'react';
import { UIText1 } from '@cian/ui-kit';

import { SidebarTip } from './SidebarTip';
import { WhatToTellAboutImage } from '../Images';
import * as s from './SidebarTips.css';

/**
 * Карточка "О чем рассказать" в сайдбаре
 */
export const SidebarWhatToTellAboutTip = () => {
  const items = [
    'Поделитесь профессиональным опытом',
    'Расскажите о «подводных камнях» при сделках с недвижимостью',
    'Выразите свое мнение о динамике цен и ситуации на рынке',
    'Обсудите с коллегами актуальные темы и события сферы',
  ];

  return (
    <SidebarTip title="О чём рассказать" image={<WhatToTellAboutImage />}>
      <ul className={s['items-wrapper']}>
        {items.map((item, index) => (
          <li key={index}>
            <UIText1>{item}</UIText1>
          </li>
        ))}
      </ul>
    </SidebarTip>
  );
};
